import { useMediaQuery } from "@mui/material";
import CollapsibleGridCard from "../CollapsibleGridCard";
import DashboardActiveProjectsColumns from "../../lib/TableColumns/DashboardActiveProjectsColumns";
import { GRID_SESSION_KEYS } from "../../lib/gridSessionState";

const ActiveProjectsTable = ({ projects }) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const columns = DashboardActiveProjectsColumns({ isMobile });

    return (
        <CollapsibleGridCard
            title="Active Projects"
            description="Opportunities with project numbers that still have at least one revenue line not marked as 07 - Revenue Taken. Archived opportunities are excluded."
            rows={projects || []}
            columns={columns}
            getRowId={(row) => row._id}
            checkboxSelection
            sessionStorageKey={GRID_SESSION_KEYS.dashboardActiveProjects}
            sessionUserId={localStorage.getItem("id")}
            initialPageSize={10}
            pageSizeOptions={[10, 25, 50]}
            variantClassName="hive-dashboard-opps-card"
            headerClassName="hive-dashboard-opps-header"
            titleClassName="hive-dashboard-opps-title"
            toggleClassName="hive-dashboard-opps-toggle"
            contentClassName="hive-dashboard-opps-content"
            gridClassName="hive-dashboard-opps-data-grid"
            titleStyle={{ margin: 0 }}
        />
    );
};

export default ActiveProjectsTable;
